import { Component, OnInit } from '@angular/core';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';

interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  videoUrl: string;
}

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrl: './videos.component.scss'
})
export class VideosComponent implements OnInit {

  header = this.translate("Videos of company branch services");
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate("Videos of company branch services"), link: '/video-content' },
  ];
  stats: stat[] = [];

  isUserLoggedIn: boolean = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private messageService: MessageService) {
    // Check if user is logged in
    this.isUserLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
  }

  ngOnInit(): void {
    // This is a public page - no authentication check needed
    // If user is not logged in, they can still view videos
    
    // Check for video ID in query parameters
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['videoId']) {
        const video = this.videos.find(v => v.id === params['videoId']);
        if (video) {
          this.openVideo(video);
        }
      }
    });
  }




  videos: Video[] = [
  {
    "id": "1",
    "title": "تأكيد السجل التجاري",
    "description": "محتوى فيديو يتعلق بتأكيد السجل التجاري (Cr Confirmation).",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Cr_Confirmation.jpg",
    "videoUrl": "assets/video-content/Cr_Confirmation.mp4"
  },
  {
    "id": "2",
    "title": "إلغاء تعليق السجل التجاري",
    "description": "محتوى فيديو يتعلق بإلغاء تعليق السجل التجاري (CR UnHold).",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/CR_UnHold.jpg",
    "videoUrl": "assets/video-content/CR_UnHold.mp4"
  },
  {
    "id": "3",
    "title": "إصدار شركة أجنبية",
    "description": "محتوى فيديو يتعلق بإصدار شركة أجنبية.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Issue_Foreign_Company.jpg",
    "videoUrl": "assets/video-content/Issue_Foreign_Company.mp4"
  },
  {
    "id": "4",
    "title": "إصدار شركة خليجية",
    "description": "محتوى فيديو يتعلق بإصدار شركة خليجية.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Issue_Gulf_Company.jpg",
    "videoUrl": "assets/video-content/Issue_Gulf_Company.mp4"
  },
  {
    "id": "5",
    "title": "تحديث شركة خليجية أجنبية",
    "description": "محتوى فيديو يتعلق بتحديث شركة خليجية أجنبية.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Update_Gulf_Foreign_company.jpg",
    "videoUrl": "assets/video-content/Update_Gulf_Foreign_company.mp4"
  },
  {
    "id": "6",
    "title": "تحديث فرع فرعي لشركة خليجية أجنبية",
    "description": "محتوى فيديو يتعلق بتحديث فرع فرعي لشركة خليجية أجنبية.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Update_Sub-Branch_Gulf_Foreign_company.jpg",
    "videoUrl": "assets/video-content/Update_Sub-Branch_Gulf_Foreign_company.mp4"
  },
  {
    "id": "7",
    "title": "تاكيد سنوى فرع شركة خليجية",
    "description": "Annual confirmation of a branch of a Gulf company",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Annual_confirmation_of_a_branch_of_a_Gulf_company.jpg",
    "videoUrl": "assets/video-content/Annual_confirmation_of_a_branch_of_a_Gulf_company.mp4"
  },
  {
    "id": "8",
    "title": "رفع تعليق فرع شركة اجنبية بموجب حكم قضائي",
    "description": "Video content related to رفع تعليق فرع شركة اجنبية بموجب حكم قضائي.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/The_suspension_of_a_foreign_company_branch_was_lifted_by_court_order.jpg",
    "videoUrl": "assets/video-content/The_suspension_of_a_foreign_company_branch_was_lifted_by_court_order.mp4"
  },
  {
    "id": "9",
    "title": "رفع تعليق فرع شركة اجنبية بناء على طلب تاجر",
    "description": "Video content related to رفع تعليق فرع شركة اجنبية بناء على طلب تاجر.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Lifting_the_suspension_of_a_foreign_company_branch_at_the_request_of_a_merchant.jpg",
    "videoUrl": "assets/video-content/Lifting_the_suspension_of_a_foreign_company_branch_at_the_request_of_a_merchant.mp4"
  },
  {
    "id": "10",
    "title": "السجل والشطب للشركات",
    "description": "Video content related to السجل والشطب للشركات.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Registration_and_deletion_for_companies.jpg",
    "videoUrl": "assets/video-content/Registration_and_deletion_for_companies.mp4"
  },
  { 
    "id": "11",
    "title": "السجل والشطب للشركات - حذف تسجيل الشركة",
    "description": "Video content related to السجل والشطب للشركات - حذف تسجيل الشركة.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/Registration_and_deletion_for_companies_-_Delete_company_registration.jpg",
    "videoUrl": "assets/video-content/Registration_and_deletion_for_companies_-_Delete_company_registration.mp4"

  },
  {
    "id": "12",
    "title": "خدمة شركة زاولت",
    "description": "Video content related to خدمة شركة زاولت.",
    "category": "خدمات الشركات",
    "thumbnail": "assets/video-content/meeting-2nd-march.jpg",
    "videoUrl": "assets/video-content/meeting-2nd-march.mp4"
  }
  ];



  categories: string[] = [...new Set(this.videos.map(v => v.category))];
  selectedCategory: string = this.categories[0] || '';
  filteredVideos: Video[] = this.videos.filter(v => v.category === this.selectedCategory);

  selectedVideo: Video | null = null;
  displayModal: boolean = false;

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.filteredVideos = this.videos.filter(v => v.category === category);
  }

  openVideo(video: Video) {
    this.selectedVideo = video;
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
    this.selectedVideo = null;
    // Clear the query parameter when closing modal
    this.router.navigate(['/video-content'], { queryParams: {} });
  }

  getShareableLink(video: Video): string {
    const baseUrl = window.location.origin;
    return `${baseUrl}/video-content?videoId=${video.id}`;
  }

  copyShareLink(video: Video) {
    const shareLink = this.getShareableLink(video);
    navigator.clipboard.writeText(shareLink).then(() => {
      this.messageService.add({ 
        severity: 'success', 
        summary: this.translate('Copied'), 
        detail: this.translate('Link copied to clipboard'), 
        life: 3000 
      });
    }).catch(() => {
      this.messageService.add({ 
        severity: 'error', 
        summary: this.translate('Error'), 
        detail: this.translate('Failed to copy link'), 
        life: 3000 
      });
    });
  }
}
